module.exports = __webpack_public_path__ + "collector-edition.jpg";